export default __webpack_public_path__ + "static/media/isPrime.18259eb9.jpg";